import { ApprovalDetailsRequestModel } from './approvalDetailsRequestModel';

export class PoApprovalCycleRequestModel{
    code : string;
    sitesId : number[];
    isEnable : boolean;
    vendorsId : number[];
    poApprovalDetails : ApprovalDetailsRequestModel[];
}